export const usePaymentStore = defineStore('payment', {
  state: () => ({
    page: 0
  }),
  actions: {
    setPage(value: number) {
      this.page = value
    }
  }
})
